import { render } from "./Message.vue?vue&type=template&id=20c44e90"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=20c44e90&lang=css"

import exportComponent from "/home/runner/work/Make_your_burger/Make_your_burger/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__